import { Control, Controller, FieldValues } from "react-hook-form";

import FormLabel from "@mui/material/FormLabel";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";

import { YesNo } from "@covertree/types";
import { SelectCard } from "../../content";

interface Props<TValues extends FieldValues> {
  id: string;
  name: string;
  control: Control<TValues>;
  label: React.ReactNode;
  onConfirmClick?: () => void;
  onDeclineClick?: () => void;
}

export const FormConditionRadioGroup = <TValues extends FieldValues>({
  id,
  name,
  control,
  label,
  onConfirmClick,
  onDeclineClick,
}: Props<TValues>): JSX.Element => {
  return (
    <Controller
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      name={name as any}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <>
            <FormLabel sx={{ display: "flex" }} error={!!error}>
              {label}
            </FormLabel>
            <RadioGroup {...field}>
              <Grid container spacing={3} sx={{ margin: "0px !important" }}>
                <Grid item xs={6}>
                  <FormControlLabel
                    id={`${id}-yes`}
                    control={<Radio sx={{ display: "none" }} />}
                    value={YesNo.Yes}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        marginLeft: 0,
                        width: "100%",
                      },
                      "& > .MuiIconButton-root": {
                        display: "none",
                      },
                    }}
                    label={
                      <SelectCard
                        title="Yes"
                        size="small"
                        hasError={!!error}
                        selected={field.value === YesNo.Yes}
                        onClick={onConfirmClick}
                      />
                    }
                  />
                </Grid>

                <Grid item xs={6}>
                  <FormControlLabel
                    id={`${id}-yes`}
                    control={<Radio sx={{ display: "none" }} />}
                    value={YesNo.No}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        marginLeft: 0,
                        width: "100%",
                      },
                      "& > .MuiIconButton-root": {
                        display: "none",
                      },
                    }}
                    label={
                      <SelectCard
                        title="No"
                        size="small"
                        hasError={!!error}
                        selected={field.value === YesNo.No}
                        onClick={onDeclineClick}
                      />
                    }
                  />
                </Grid>
              </Grid>
            </RadioGroup>
          </>
        );
      }}
    />
  );
};
